module.exports = __webpack_public_path__ + "img/logo_donya.8143bb46.svg";